const subheader = [{"key":"subheader.contribute_button","string":"Přispět"},{"key":"subheader.home","string":"Start"},{"key":"subheader.start","string":"Odborná platforma"},{"key":"subheader.contribute","string":"Přispět"},{"key":"subheader.confirm_account","string":"Potvrdit účet"},{"key":"subheader.reset_password","string":"Obnovit heslo"},{"key":"subheader.knowledge_repository","string":"Znalostní databáze"},{"key":"subheader.yellow_pages","string":"Žluté stránky"}]

export default subheader



// WEBPACK FOOTER //
// ./src/i18n/cs/subheader/_subheader.js